import {
    MASK,
} from './constants';

export function checkValue(value: string): boolean {
    const [hours, minutes] = value.split(':');

    if (hours) {
        if (hours[0]) {
            if (!/[0-2]/.test(hours[0])) {
                return false;
            }
        }
        if (hours[1]) {
            if (hours[0] === '2') {
                if (!/[0-3]/.test(hours[1])) {
                    return false;
                }
            }
        }
    }
    if (minutes) {
        if (minutes[0]) {
            if (!/[0-5]/.test(minutes[0])) {
                return false;
            }
        }
    }

    return true;
}

export function formatValue(value: string): string | null {
    if (value.length !== MASK.length) {
        return null;
    }

    return value;
}
